import { type ITokenStorage } from './ITokenStorage';

export class TokenStorage implements ITokenStorage {
  private readonly TOKEN_KEY = 'auth_token';

  public saveToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  public removeToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  public hasToken(): boolean {
    return this.getToken() !== null;
  }
}
